import type { Code } from './code-compiletime';

export default import.meta.compileTime<Code>('./code-compiletime.ts');